import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";








import { PrimaryCutting } from "../../../../timber/types/models/Cutting";

import CuttingFormSelect from "../../../../timber/components/cutting/CuttingForm/CuttingFormSelect";

import { useGetCuttingQuery } from "../../../../timber/apis/Cutting.api";

import LocationFormSelect from "../../../../location/components/location/LocationForm/LocationFormSelect";

import { PrimaryForestOwner } from "../../../../timber/types/models/ForestOwner";

import ForestOwnerFormSelect from "../../../../timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect";






import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";



















export const initialFormStateFn = () => { return {
    
        
        name: "",
        
    
        
        cuttingId: null,
        
    
        
        locationId: null,
        
    
        
        forestOwnerId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.cuttingId = PrimaryCutting.fromQuery(location.state?.cuttingId) || null;
    initialFormState.forestOwnerId = PrimaryForestOwner.fromQuery(location.state?.forestOwnerId) || null;
    

    const { data: cuttingIdData } = useGetCuttingQuery(PrimaryCutting.fromId(initialFormState.cuttingId), { skip: !initialFormState.cuttingId })
    initialFormState.forestOwnerId = initialFormState.forestOwnerId || cuttingIdData?.forestOwnerId || null;
    initialFormState.locationId = initialFormState.locationId || cuttingIdData?.locationId || null;
    

    return React.useMemo(() => initialFormState, [
        location.state,
        cuttingIdData,
        
        initialFormState.forestOwnerId,
        initialFormState.locationId,
        
    ])
}

export const formObject = {
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        cuttingId:
        string()
                .nanoid(msg`Cutting is required`)
                .min(1, msg`Cutting is required`),
    
    
        locationId:
        string()
                .nanoid(msg`Location is required`)
                .min(1, msg`Location is required`),
    
    
        forestOwnerId:
        string()
                .nanoid(msg`Forest Owner is required`)
                .nullish(),
    
};

export const formSchema = object(formObject);

const TimberStorageAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
           
           
   
    
    <CuttingFormSelect
        type="dynamicSelect"
        name="cuttingId"
        label={t`Cutting`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <LocationFormSelect
        type="dynamicSelect"
        name="locationId"
        label={t`Location`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <ForestOwnerFormSelect
        type="dynamicSelect"
        name="forestOwnerId"
        label={t`Forest Owner`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
        </Container>
    )
}

export default TimberStorageAddForm;
